import React, { useEffect, useState } from 'react';
import { Post as PostModel } from 'redux/models/post';
import { Grid } from '@material-ui/core';
import { formatPostDate } from 'helpers/helper';
import moment from 'moment';
import { Divider } from '@material-ui/core';
import './PostEvent.scss';

interface PostProps {
	post: PostModel;
}

const PostEvent: React.FC<PostProps> = (props: PostProps) => {
	const { post } = props;
	const [postDate, setPostDate] = useState<string>('');

	useEffect(() => {
		setPostDate(formatPostDate(post.createdOn));
	}, [post.createdOn]);

	return (
		<>
			<Grid item className='leave-post-item'>
				<Grid container direction='row' className='leave-post-item__title' alignItems='center'>
					<Grid item sm={3}>
						<Divider className='leave-post__divider' />
					</Grid>
					<Grid container item xs={12} sm={6} justifyContent='center'>
						<Grid item direction='column' container>
							<div className='leave-post-item__comment-content'>{post.comment}</div>
							<div className='leave-post-timestamp' title={moment(post.createdOn).format('MMMM DD, YYYY @ h:mm A')}>
								{postDate}
							</div>
						</Grid>
					</Grid>
					<Grid item sm={3}>
						<Divider className='leave-post__divider' />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default PostEvent;
